import React from "react";
import { CLIENTS } from "../mock";
import { Building } from "lucide-react";

export default function Clients() {
  const loop = [...CLIENTS, ...CLIENTS];
  return (
    <section id="clients" className="py-20 bg-slate-50 border-y border-slate-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-yellow-700">Trusted Partners</div>
          <h2 className="display section-underline center mt-3 text-4xl md:text-5xl font-extrabold text-slate-900 uppercase">
            Our Esteemed Clients
          </h2>
          <p className="mt-4 text-slate-600">India’s most respected developers, contractors and brands rely on NEWCON.</p>
        </div>

        <div className="mt-12 overflow-hidden">
          <div className="flex marquee-track gap-6 w-max">
            {loop.map((c, i) => (
              <div
                key={`${c}-${i}`}
                className="shrink-0 w-60 h-24 bg-white border border-slate-200 rounded-lg grid place-items-center px-6 hover:border-yellow-500 hover:shadow-md transition-all"
              >
                <div className="flex items-center gap-3">
                  <Building className="w-5 h-5 text-yellow-700" />
                  <span className="font-bold text-slate-800 tracking-tight">{c}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
